import * as React from 'react';

import classNames from 'classnames';

interface ICardHeaderProps {
	icon?: string;
	onClick?: (event?) => void;
	isLoading?: boolean;
}

export default class Card extends React.Component<ICardHeaderProps, {}> {
	public render() {
		const { icon, onClick, isLoading } = this.props;

		const iconClasses = classNames(
			'fa',
			'fa-2x',
			isLoading ? 'fa-spinner fa-spin' : `fa-${icon}`
		);

		const cardHeaderIcon = icon && (
			<a className="card-header-icon">
				<span className="icon">
					<i className={iconClasses} />
				</span>
			</a>
		);

		const cardHeaderClasses = classNames(
			'card-header',
			onClick && 'is-clickable'
		);

		return (
			<header className={cardHeaderClasses} onClick={onClick}>
				<span className="card-header-title">{this.props.children}</span>
				{cardHeaderIcon}
			</header>
		);
	}
}
